<template>
    <div class=""> 
        <p class="my-0">Para poder aperturar programas en las sedes, los programas deben tener un posgrado, caso contrario no estara disponible para nadie.</p>
        <small>Fecha de aprobacion del proyecto:</small> 
        <v-row>
            <v-col xs="6" sm="2" md="3" lg="2">
                <v-select :items="meses()" v-model="filtros.mes" item-value="id" label="Mes:" dense outlined />
            </v-col> 
            <v-col xs="6" sm="2" md="3" lg="2">
                <v-select :items="gestiones" v-model="filtros.anio" item-value="id" label="Gestion:" dense outlined />
            </v-col>
            <v-col xs="6" sm="2" v-if="false">
                <!-- funciona pero hay que filtrar por unidad negocio en el back payment -->
                <v-checkbox v-model="omitir_sede" color="blue" label="omitir sede" outlined dense :loading="loading"> </v-checkbox>
            </v-col>
            <v-col xs="6" sm="2">
                <v-btn color="blue" outlined dark :loading="loading" @click="getDatos()">Filtrar</v-btn>
            </v-col>
            <v-col xs="6" sm="2">
                <v-text-field outlined dense placeholder="buscar..." v-model="filter" />
            </v-col>
        </v-row>
        <v-divider class="mt-0 mb-4" />

        <v-data-table
            :headers="headers"
            :items="desserts"
            :loading="loading" 
            :search="filter"
            dense
            disable-pagination 
            hide-default-footer
            :items-per-page="50"
            class="elevation-0">
    
            <template v-slot:[`item.ind`]="a">
                <span> {{ a.index + 1 }} </span>
            </template>
            <template v-slot:[`item.proyecto_fecha_aprobacion`]="{item}">
                <span> {{ parseFecha(item.proyecto_fecha_aprobacion) }} </span>
            </template>
            <template v-slot:[`item.fecha_inicio`]="{item}">
                <span> {{ parseFecha(item.fecha_inicio) }} </span>
            </template>
            <template v-slot:[`item.fecha_fin`]="{item}">
                <span> {{ parseFecha(item.fecha_fin) }} </span>
            </template>
            <template v-slot:[`item.opt`]="{item}"> 
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="orange" dark v-bind="attrs" v-on="on" @click="crearPosgrado(item)" outlined small >
                            <v-icon>mdi-folder-plus</v-icon>
                        </v-btn>
                    </template>
                    <span>Crear posgrado</span>
                </v-tooltip>
                <!-- <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="my-0 py-0" color="primary" small dark v-bind="attrs" v-on="on"> : </v-btn>
                    </template>
                    <v-list>
                        <v-list-item link @click="crearPosgrado(item)">
                            <v-list-item-title>
                                <v-icon>mdi-plus</v-icon>
                                Crear posgrado
                            </v-list-item-title>
                        </v-list-item> 
                    </v-list>
                </v-menu>  -->
            </template>

        </v-data-table> 

        <CrearPosgrado ref="refCrearPosgrado" v-on:onsuccess="onsuccess" />
    </div>
</template>
  
<script>
import xaxios from '@/xaxios';
import {parseFecha, meses,gestionesAsync} from '../util.ts' 
import CrearPosgrado from './crear-posgrado.vue'

export default {
    components: {CrearPosgrado},
    props:{
        shared:{type:Object, required:false}, 
    },
    data() {
        return {
            loading: false,
            headers: [ 
                { text: '#', value: 'ind' },
                { text: 'Programa universidad', value: 'programa_nombre', width:'350' },
                { text: 'Codigos', value: 'codigos', width:'125' },
                { text: 'Aprobado', value: 'proyecto_fecha_aprobacion' },
                { text: 'Resolucion', value: 'resolucion_aprobacion_universidad' },
                // { text: 'pid', value: 'proyecto_id' },
                // { text: 'Fecha inicio', value: 'fecha_inicio' },
                // { text: 'Fecha fin', value: 'fecha_fin' },
                { text: '', value: 'opt' },
            ],
            desserts: [],
            parseFecha,
            meses,
            gestiones:[],
            filtros:{
                mes:null,
                anio: null,
            },
            filter:'',
            omitir_sede: false,
            tabs: null
        };
    },
    watch: {
        '$store.state.CARGO': function(){
            this.getDatos();
        }, 
    },
    methods: {
        async getDatos(){
            const idsede = this.$store.state.CARGO.idsede;
            const unidad = this.$store.state.CARGO.sede.unidad_negocio;
            const m = this.filtros.mes;
            const a = this.filtros.anio;
            this.shared.mes = this.filtros.mes;
            this.shared.anio = this.filtros.anio;
            let omit = 'omit_sede=0';
            if(this.omitir_sede) omit ='omit_sede=1';
            const ps = `ofertas-academicas/autoria?sede_id=${idsede}&unidad_negocio_id=${unidad}&mes_aprobacion=${m}&gestion_aprobacion=${a}&con_posgrado=0&${omit}`;
            const url = process.env.VUE_APP_URL_API_PAGOS2+ps;
            this.desserts = [];
            this.loading = true;
            const res = await xaxios.get(url).then(({data})=>data).catch(e=>e);
            // window.console.log('res', res);
            if(res) {
                this.desserts = res.datos;
            }
            this.loading = false;
        }, 
        async getGestiones() {
            this.loading = true;
            const gs = await gestionesAsync(this);
            this.gestiones = gs;
            this.loading = false;

            const d = new Date();
            const m = d.getMonth()+1;
            const anio = d.getFullYear(); 

            if(this.shared.mes) this.filtros.mes = this.shared.mes;
            else this.filtros.mes = m; 
            
            if(this.shared.anio) this.filtros.anio = this.shared.anio;
            else this.filtros.anio = anio; 
            
            this.getDatos(); 
        },

        onsuccess(proy, post){
            window.console.log('onsucess:::', proy,post);
            
            this.desserts = this.desserts.filter(x=>x.id!=proy.id)
        },

        //
        async crearPosgrado(proy){
            this.$refs.refCrearPosgrado.openmodal(proy);
            /*const unidad = this.$store.state.CARGO.sede.unidad_negocio;
            const data = {};
            data.idarea = mapArea(proy.area_universidad_id);
            data.idcategoria = mapCategoria(proy.categoria_universidad_id);
            data.nombre = proy.programa_nombre;
            data.portada = 'portadita.jpg';
            data.creditaje = 30;
            data.duracion = 6;
            data.unidad_duracion = 0;
            data.carga_horaria = 800;
            data.unidad_negocio_id = unidad;
            window.console.log('crear programa de: ', proy,data);
            let sql = gql`mutation{ createPostgrado(input:${window.stringifyObject(data)}){ok,postgrado{id,nombre,unidad_duracion},errors{message}} }`;
            let res = await this.$apollo.mutate({  mutation: sql }).then(({ data }) => data).catch(e=>e);
            window.console.log('res:::', res);
            if(res && res.createPostgrado){
                let posgrado_id = res.createPostgrado.postgrado.id;
                // let posgrado_id = 3004;
                let url = process.env.VUE_APP_URL_API_PAGOS2+'programa-universidad/'+proy.codigo+'/update-posgrado-id'

                let resp = await fetch(url, {
                    method: "PATCH",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ posgrado_id: posgrado_id })
                }).then(response => response.json()).then(data => data).catch(error => error);

                window.console.log('posssss',resp);
                

            }*/
            
        }
    },
    activated:{

    },
    mounted() {
        this.desserts = [];
        this.getGestiones(); 
    },
};
</script>
  